<template>
  <div class="children-general">

    <p v-if="isLoading">
      Laden...
    </p>

    <p v-else-if="isLoading === false && carers.length < 1">
      Geen verzorgers gevonden
    </p>

    <div v-else>
      <span v-bind:key="key" v-for="(carer, key) in carers">
        <div class="row">
          <div class="col-12">
            <h3>Verzorger {{ (key + 1) }}</h3>
          </div>
          <template v-for="data in carer" v-bind:key="data.title">
              <div class="col-12">
                <h4>{{ translate(data.title) }}</h4>
              </div>
              <template v-for="dataField in data.fields" v-bind:key="dataField.functionName">
                <div class="col-12 col-sm-3">
                  {{ translate(dataField.name) }}
                </div>
                <div class="col-12 col-sm-9">
                  {{ translate(dataField.displayValue) }}
                </div>
              </template>
            </template>
        </div>
        <br>
      </span>
    </div>

  </div>
</template>

<script>
export default {
  name: 'children-general',
  props: ['id'],
  data() {
    return {
      isLoading: false,
      carers: []
    }
  },
  created() {
    this.getCarers()
  },
  methods: {
    getCarers() {
      this.isLoading = true
      let query = '?id_child=' + this.selectedChild.id
      if (this.isGastouderapp()) {
        query += '&gastouderapp'
      }
      this.$request.get('/carers/forms' + query)
          .then((response) => {
            this.isLoading = false
            if (!response.data) {
              return
            }
            this.carers = response.data
          })
    }
  }
}
</script>

<style scoped>
</style>
